import { apiClient } from './api';
import { ServiceRequest, PaginatedResponse } from '../types';

interface BackendPaginatedResponse<T> {
  data: T[];
  total: number;
  page: number;
  pages: number;
}

class ServiceRequestService {
  async getAllRequests(filters?: {
    status?: string;
    priority?: string;
    page?: number;
    limit?: number;
  }): Promise<PaginatedResponse<ServiceRequest>> {
    const response = await apiClient.get<BackendPaginatedResponse<ServiceRequest>>('/admin/service-requests', filters);
    // Convert backend format to frontend format
    return {
      items: response.data,
      total: response.total,
      page: response.page,
      limit: filters?.limit || 10,
      totalPages: response.pages
    };
  }

  async updateRequestStatus(id: string, status: string, notes?: string): Promise<ServiceRequest> {
    return apiClient.patch<ServiceRequest>(`/admin/service-requests/${id}`, { status, notes });
  }

  async assignRequest(id: string, assignedTo: string): Promise<ServiceRequest> {
    return apiClient.patch<ServiceRequest>(`/admin/service-requests/${id}`, { assignedTo });
  }

  async updatePriority(id: string, priority: string): Promise<ServiceRequest> {
    return apiClient.patch<ServiceRequest>(`/admin/service-requests/${id}`, { priority });
  }

  async createRequest(data: {
    type: string;
    details: string;
    priority?: string;
  }): Promise<ServiceRequest> {
    return apiClient.post<ServiceRequest>('/member/service-requests', data);
  }

  async getMemberRequests(filters?: {
    status?: string;
    page?: number;
    limit?: number;
  }): Promise<PaginatedResponse<ServiceRequest>> {
    const response = await apiClient.get<BackendPaginatedResponse<ServiceRequest>>('/member/service-requests', filters);
    // Convert backend format to frontend format
    return {
      items: response.data,
      total: response.total,
      page: response.page,
      limit: filters?.limit || 10,
      totalPages: response.pages
    };
  }

  async getRequestById(id: string): Promise<ServiceRequest> {
    return apiClient.get<ServiceRequest>(`/member/service-requests/${id}`);
  }
}

export const serviceRequestService = new ServiceRequestService();
